import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';

import { LocaleSetAction } from '../domains/locales/actions';
import {
  TranslationsLoadFulfilledAction,
  TranslationsLoadPendingAction,
  TranslationsLoadRejectedAction,
} from '../domains/translations/actions';

import { I18nState } from './types';

const initialState: I18nState = {
  currentLocale: '',
  previousLocale: '',
  translations: {
    pending: { byId: {} },
    fulfilled: {
      byId: {},
    },
    rejected: { byId: {} },
  },
};

export type I18nAction =
  | LocaleSetAction
  | TranslationsLoadFulfilledAction
  | TranslationsLoadPendingAction
  | TranslationsLoadRejectedAction;

export const i18nReducer: (state: I18nState | undefined, action: I18nAction) => I18nState = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case '@@yammer-i18n-react/LOCALE.SET':
      return {
        ...state,
        currentLocale: action.payload,
        previousLocale: state.currentLocale,
      };
    case '@@yammer-i18n-react/TRANSLATIONS.LOAD_FULFILLED':
      return {
        ...state,
        translations: moveToFulfilled(state.translations, action.payload),
      };
    case '@@yammer-i18n-react/TRANSLATIONS.LOAD_PENDING':
      return {
        ...state,
        translations: moveToPending(state.translations, [action.payload.id]),
      };
    case '@@yammer-i18n-react/TRANSLATIONS.LOAD_REJECTED':
      return {
        ...state,
        translations: moveToRejected(state.translations, [action.payload.id], action.payload.error),
      };
    default:
      return state;
  }
};
